import { Link } from "react-router-dom";
import { seoArticles } from "@/mocks/articles";

export default function ArticleCTA() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            GTBuy Spreadsheet Guides &amp; Resources
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            Deepen your knowledge with our comprehensive collection of <strong>GTBuy spreadsheet</strong> articles covering order tracking, platform comparisons, and expert shopping strategies.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {seoArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group rounded-xl bg-background-100 border border-background-200 overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer hover:-translate-y-1"
            >
              <div className="relative w-full h-[200px] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  loading="lazy"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-700 transition-colors duration-200 line-clamp-2 leading-snug mb-2">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="mt-3 flex items-center gap-1.5 text-xs font-medium text-primary-600">
                  <span>Read Article</span>
                  <i className="ri-arrow-right-line w-3.5 h-3.5 flex items-center justify-center"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/what-is-gtbuy-spreadsheet"
            className="whitespace-nowrap inline-flex items-center gap-2 px-7 py-3 rounded-full bg-accent-500 text-white font-semibold text-sm md:text-base hover:bg-accent-600 transition-all duration-300 cursor-pointer hover:scale-105"
          >
            <i className="ri-book-open-line w-5 h-5 flex items-center justify-center"></i>
            View Our Featured Guide
          </Link>
        </div>
      </div>
    </section>
  );
}